/* eslint-disable */
//tslint:disable

export interface ILayoutRoomCountSchema {
  /** Есть ли квартиры с данной комнатностью **/
  isAvailable?: boolean | null;
  /** Значение для отрисовки на фронте (например '1') **/
  roomTitle: string;
  /** Значение для отправки на бэкенд (напримем oneRoom) **/
  roomValue: ERoomValue;
}

export enum ERoomValue {
  /**  **/
  FourPlusRoom = 'fourPlusRoom',
  /**  **/
  OneRoom = 'oneRoom',
  /**  **/
  Studio = 'studio',
  /**  **/
  ThreeRoom = 'threeRoom',
  /**  **/
  TwoRoom = 'twoRoom',
}
